<template>
<div class="service_box">
  <div v-html="html"></div>
  <p class="read">请仔细阅读<span> 3 </span>s 后可提交</p>
  <section class="agree">
    <span class="quar"></span>
    <span class="agree_text">本人已阅读并同意</span>
  </section>
  <common-footer text="确认提交" :canClick="canClick" @btnClick="btnClick"></common-footer>
</div>
</template>

<script>
import CommonFooter from '../../components/footer';
import util from '../../utils/util';
import {} from '../../utils/api';
 import wx from 'weixin-js-sdk';
//import wx from 'jweixin-1.6.0'
import {mapState} from 'vuex';
export default {
  name: 'parkingAgreement',
  props: {},
  components: {
    CommonFooter
  },
  filters: {
  },
  computed: {
    ...mapState({
      common: state => state.common
    })
  },
  data() {
    return {
      html:'',
      canClick:true
    }
  },
  created() {
  },
  mounted(){

  },
  methods: {
    btnClick(){

    }
  }
};
</script>
<style lang="less" scoped>
@import "../../assets/css/common.less";
.service_box{
  .read{
    position:fixed;
    bottom:108px;
    left:0;right:0;
    height:106px;
    line-height:106px;
    text-align: center;
    span{
      color:#FD9838;
      font-size:40px;
    }
  }
}
</style>
